 <template>
  <div class="add-order">
    <el-form ref="form" label-width="150px">
      <el-row class="form-title">基础信息</el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="返优惠使用规则名称">{{detailData.name}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="返优惠使用规则编码">{{detailData.code}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="下单适用协议类型">{{detailData.orderProtocolName}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="使用规则有效期">{{(detailData.effectiveStartDate||'').slice(0,10)}} - {{(detailData.effectiveEndDate||'').slice(0,10)}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="状态">{{detailData.statusName}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="创建人">{{detailData.createPerson}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="创建时间">{{detailData.createTime}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="提交审核时间">{{detailData.submitApplyDate}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="审核时间">{{detailData.applyDate}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="作废人">{{detailData.invalidCardNo}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="作废时间">{{detailData.invalidDate}}</el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="作废原因">{{detailData.invalidReason}}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-card class="form-card" v-for="(item, index) in detailData.rules" :key="index">
      <el-row class="form-title">规则{{index+1}}</el-row>
      <el-row class="form-top">使用金额限制: <span style="margin-left: 10px">{{item.rule === 0 ? '按每吨总优惠金额使用限制，每吨总优惠金额不超过':'按每吨返优惠使用限制，每吨返优惠金额上限'}}{{item.amount}}元</span>
      </el-row>
      <el-row class="form-top">适用商品
      </el-row>
      <el-table
        :data="item.showGoodsList"
        style="width: 100%">
        <el-table-column
          label="商品名称"
          prop="itemName">
        </el-table-column>
        <el-table-column
          label="商品编码"
          prop="itemCode">
        </el-table-column>
      </el-table>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="item.goodsPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="item.itemInfos ? item.itemInfos.length:0"
        :current-page="item.goodsPageNo"
        background
        @current-change="e => handleCurrentChange(e, index)"
        @size-change="e => handleSizeChange(e, index)">
      </el-pagination>
    </el-card>
      <el-row class="form-top">适用客户范围: <span style="margin-left: 10px">{{applicableCustomerStr[detailData.applicableCustomer]}}</span>
      </el-row>
      <el-table
        v-if="detailData.applicableCustomer"
        :data="customerInfo.data"
        style="width: 100%">
        <el-table-column
          label="客户名称"
          prop="customerName">
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="detailData.applicableCustomer"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="customerInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="detailData.customerDtos.length"
        :current-page="customerInfo.pageNo"
        background
        @current-change="handleCurrentChangeCustomer"
        @size-change="handleSizeChangeCustomer">
      </el-pagination>
      <el-row class="action-bottom">
        <el-button @click="handleClose">返 回</el-button>
      </el-row>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'lookRebateRuleUse',
  components: { },
  data () {
    return {
      id: this.$route.query.id,
      detailData: {},
      applicableCustomerStr: {
        0: '全部客户',
        1: '指定客户',
        2: '排除指定客户'
      },
      customerInfo: {
        data: [],
        pageSize: 10,
        pageNo: 1
      }
    }
  },
  computed: {
  },
  mounted () {
    this.queryDetail()
  },
  methods: {
    ...mapActions(['addRebateUsePolicy', 'usePolicyFindOne']),
    queryDetail () {
      this.usePolicyFindOne({ id: this.id }).then(res => {
        if (res.success) {
          this.detailData = res.data
          this.handleChangePage()
          this.handleChangeCustomer()
        }
      })
    },
    handleChangePage () {
      this.detailData.rules = this.detailData.rules.map(rule => {
        const goodsPageSize = rule.goodsPageSize || 10
        const goodsPageNo = rule.goodsPageNo || 1
        return {
          ...rule,
          goodsPageSize,
          goodsPageNo,
          showGoodsList: this.$lodash.cloneDeep(rule.itemInfos).splice(goodsPageSize * (goodsPageNo - 1), goodsPageSize)
        }
      })
    },
    // 分页条数变更
    handleSizeChange (val = 10, index) {
      this.detailData.rules[index].goodsPageSize = val
      this.detailData.rules[index].goodsPageNo = 1
      this.handleChangePage()
    },
    // 分页跳转
    handleCurrentChange (val = 1, index) {
      this.detailData.rules[index].goodsPageNo = val
      this.handleChangePage()
    },

    // 客户分页
    handleChangeCustomer () {
      const { pageSize, pageNo } = this.customerInfo
      this.customerInfo.data = this.$lodash.cloneDeep(this.detailData.customerDtos).splice(pageSize * (pageNo - 1), pageSize)
    },
    handleCurrentChangeCustomer (val = 1) {
      this.customerInfo.pageNo = val
      this.handleChangeCustomer()
    },
    handleSizeChangeCustomer  (val = 10) {
      this.customerInfo.pageSize = val
      this.customerInfo.pageNo = 1
      this.handleChangeCustomer()
    },
    handleClose () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.add-order{
  .input-width{
    width: 300px;
  }
  .form-item-inline{
    display: inline-block;
  }
  .form-title {
    font-weight: bold;
    margin-bottom: 20px;
    font-size: 15px;
  }
  .form-top, .form-card{
    margin-bottom: 15px;
  }
  .form-limit{
    margin-top: 8px;
  }
  .export-btn{
    float: right;
  }
  .action-bottom{
    margin-top: 20px;
  }
}
</style>
